import { withAntdTheme } from "global/hoc";
import Navigation from "navigation";

const App = () => {
  return <Navigation />;
};

export default withAntdTheme(App);
